import React from 'react'
import BreadCrumb from '../components/BreadCrumb';
import Meta from '../components/Meta';
import { Link } from 'react-router-dom';
import Container from '../components/Container';
import Custominput from '../components/Custominput';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useDispatch } from "react-redux";
import { registerUser } from '../features/user/userSlice';


const signUpSchema = yup.object({
  firstname: yup.string().required('First name is required'),
  lastname: yup.string().required('Last name is required'),
  email: yup.string().required('Please provide a valid email'),
  mobile: yup.string().required('Mobile number is required'),
  password: yup.string().required('Password is required'),
});

const Signup = () => {
    const dispatch = useDispatch();
    const formik = useFormik({
        initialValues: {
          firstname: '',
          lastname: '',
          email: '',
          mobile: '',
          password: '',
        },
        validationSchema: signUpSchema,
        onSubmit: values => {
          dispatch(registerUser(values))
        },
      });
  return (
    <>
        <Meta title={'Signup'} />
        <BreadCrumb title='Signup'/>
        <Container class1='login-wrapper py-5 home-wrapper-2'>
            <div className='row'>
                <div className='col-12'>
                    <div className='auth-card'>
                        <h3 className='text-center mb-3'>Create Account</h3>
                        <form action='' onSubmit={formik.handleSubmit} className='mt-3 d-flex flex-column gap-15'>
                            <Custominput 
                                type='text' 
                                name='firstname' 
                                placeholder='First name' 
                                value={formik.values.firstname} 
                                onChange={formik.handleChange("firstname")} 
                                onBlur={formik.handleBlur("firstname")} 
                            />
                            <div className="error">
                                {formik.touched.firstname && formik.errors.firstname}
                            </div>
                            <Custominput 
                                type='text' 
                                name='lastname' 
                                placeholder='Last name' 
                                value={formik.values.lastname} 
                                onChange={formik.handleChange("lastname")} 
                                onBlur={formik.handleBlur("lastname")} 
                            />
                            <div className="error">
                                {formik.touched.lastname && formik.errors.lastname}
                            </div>
                            <Custominput 
                                type='email' 
                                name='email' 
                                placeholder='Email'
                                value={formik.values.email} 
                                onChange={formik.handleChange("email")} 
                                onBlur={formik.handleBlur("email")} 
                            />
                            <div className="error">
                                {formik.touched.email && formik.errors.email}
                            </div>
                            <Custominput 
                                type='tel' 
                                name='mobile' 
                                placeholder='Mobile number' 
                                value={formik.values.mobile} 
                                onChange={formik.handleChange("mobile")} 
                                onBlur={formik.handleBlur("mobile")} 
                            />
                            <div className="error">
                                {formik.touched.mobile && formik.errors.mobile}
                            </div>
                            <Custominput 
                                type='password' 
                                name='password' 
                                placeholder='Password' 
                                value={formik.values.password} 
                                onChange={formik.handleChange("password")} 
                                onBlur={formik.handleBlur("password")} 
                            />
                            <div className="error">
                                {formik.touched.password && formik.errors.password}
                            </div>
                            <div>
                                <div className='mt-3 d-flex justify-content-center gap-15 align-items-center'>
                                    <button className='button border-0' type='submit'>Submit</button>
                                    <Link to='/login' className='button signup'>Login</Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Container>
    </>
  )
}

export default Signup